import { token } from '@atlaskit/tokens';

export enum CONTENT_WIDTH {
	NARROW = 'narrow',
	WIDE = 'wide',
	FULL = 'full',
}
export const DEFAULT_CONTENT_WIDTH: CONTENT_WIDTH.WIDE = CONTENT_WIDTH.WIDE;
export const DEFAULT_BACKGROUND_COLOR: "var(--ds-surface)" = token('elevation.surface');
export const HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE =
	'com.atlassian.confluence.hub-element-placeholder';
export const HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY = 'hub-element-placeholder';
export const sectionExtensionKey = 'hub-section';
export const sectionExtensionType = 'com.atlassian.confluence.hub-section';
